// extracted by mini-css-extract-plugin
module.exports = {"emptyState":"_2PCov","ProductPageApp":"_1TImB","productPageApp":"_1TImB"};